import { Action } from '@ngrx/store';
import { type } from '../shared/helpers';

export const ActionTypes = {
    REGISTER_USER: type('REGISTER_USER'),
    REGISTER_USER_SUCCESS: type('REGISTER_USER_SUCCESS'),
    REGISTER_USER_FAIL: type('REGISTER_USER_FAIL'),
    CLEAR_REGISTER_STATE: type('CLEAR_REGISTER_STATE'),

    LOGIN_USER: type('LOGIN_USER'),
    LOGIN_USER_SUCCESS: type('LOGIN_USER_SUCCESS'),
    LOGIN_USER_FAIL: type('LOGIN_USER_FAIL'),
    CLEAR_LOGIN_STATE: type('CLEAR_LOGIN_STATE'),

    SEND_PASSWORD_RECOVERY_KEY: type('SEND_PASSWORD_RECOVERY_KEY'),
    SEND_PASSWORD_RECOVERY_KEY_SUCCESS: type('SEND_PASSWORD_RECOVERY_KEY_SUCCESS'),
    SEND_PASSWORD_RECOVERY_KEY_FAIL: type('SEND_PASSWORD_RECOVERY_KEY_FAIL'),
    CLEAR_SEND_PASSWORD_RECOVERY_KEY_STATE: type('CLEAR_SEND_PASSWORD_RECOVERY_KEY_STATE'),

    CHANGE_PASSWORD: type('CHANGE_PASSWORD'),
    CHANGE_PASSWORD_SUCCESS: type('CHANGE_PASSWORD_SUCCESS'),
    CHANGE_PASSWORD_FAIL: type('CHANGE_PASSWORD_FAIL'),
    CLEAR_CHANGE_PASSWORD_STATE: type('CLEAR_CHANGE_PASSWORD_STATE'),

    DO_LOGOUT: type('DO_LOGOUT'),
    DO_LOGOUT_SUCCESS: type('DO_LOGOUT_SUCCESS'),

    GET_CURRENT_USER: type('GET_CURRENT_USER'),
    GET_CURRENT_USER_FAIL: type('GET_CURRENT_USER_FAIL'),
    GET_CURRENT_USER_SUCCESS: type('GET_CURRENT_USER_SUCCESS'),
    CLEAR_GET_CURRENT_USER_STATE: type('CLEAR_GET_CURRENT_USER_STATE'),

    GET_USERS_LIST: type('GET_USERS_LIST_'),
    GET_USERS_LIST_FAIL: type('GET_USERS_LIST_FAIL_'),
    GET_USERS_LIST_SUCCESS: type('GET_USERS_LIST_SUCCESS_'),
    CLEAR_GET_USERS_LIST_STATE: type('CLEAR_GET_USERS_LIST_STATE_'),

    UPDATE_USER_ITEM: type('UPDATE_USER_ITEM'),
    UPDATE_USER_ITEM_FAIL: type('UPDATE_USER_ITEM_FAIL'),
    UPDATE_USER_ITEM_SUCCESS: type('UPDATE_USER_ITEM_SUCCESS'),
    CLEAR_UPDATE_USER_ITEM_STATE: type('CLEAR_UPDATE_USER_ITEM_STATE'),

    IMPORT_USERS_FROM_FILE: type('IMPORT_USERS_FROM_FILE'),
    IMPORT_USERS_FROM_FILE_FAIL: type('IMPORT_USERS_FROM_FILE_FAIL'),
    IMPORT_USERS_FROM_FILE_SUCCESS: type('IMPORT_USERS_FROM_FILE_SUCCESS'),
    CLEAR_IMPORT_USERS_FROM_FILE_STATE: type('CLEAR_IMPORT_USERS_FROM_FILE_STATE'),

    UPDATE_USER_ROLE: type('UPDATE_USER_ROLE'),
    UPDATE_USER_ROLE_SUCCESS: type('UPDATE_USER_ROLE_SUCCESS'),
    UPDATE_USER_ROLE_FAIL: type('UPDATE_USER_ROLE_FAIL'),
    CLEAR_UPDATE_USER_ROLE_STATE: type('CLEAR_UPDATE_USER_ROLE_STATE'),

    REMOVE_USER_ROLE: type('REMOVE_USER_ROLE'),
    REMOVE_USER_ROLE_SUCCESS: type('REMOVE_USER_ROLE_SUCCESS'),
    REMOVE_USER_ROLE_FAIL: type('REMOVE_USER_ROLE_FAIL'),
};

export class RegisterUserAction implements Action {
    type = ActionTypes.REGISTER_USER;
    constructor(public payload: any) { }
}
export class RegisterUserFailAction implements Action {
    type = ActionTypes.REGISTER_USER_FAIL;
    constructor(public payload: any) { }
}
export class RegisterUserSuccessAction implements Action {
    type = ActionTypes.REGISTER_USER_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearRegisterStateAction implements Action {
    type = ActionTypes.CLEAR_REGISTER_STATE;
    constructor(public payload: any) { }
}

export class LoginUserAction implements Action {
    type = ActionTypes.LOGIN_USER;
    constructor(public payload: any) { }
}
export class LoginUserSuccessAction implements Action {
    type = ActionTypes.LOGIN_USER_SUCCESS;
    constructor(public payload: any) { }
}
export class LoginUserFailAction implements Action {
    type = ActionTypes.LOGIN_USER_FAIL;
    constructor(public payload: any) { }
}
export class ClearLoginStateAction implements Action {
    type = ActionTypes.CLEAR_LOGIN_STATE;
    constructor(public payload: any) { }
}

export class SendPasswordRecoveryKeyAction implements Action {
    type = ActionTypes.SEND_PASSWORD_RECOVERY_KEY;
    constructor(public payload: any) { }
}
export class SendPasswordRecoveryKeyFailAction implements Action {
    type = ActionTypes.SEND_PASSWORD_RECOVERY_KEY_FAIL;
    constructor(public payload: any) { }
}
export class SendPasswordRecoveryKeySuccessAction implements Action {
    type = ActionTypes.SEND_PASSWORD_RECOVERY_KEY_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearSendRecoveryPasswordKeyStateAction implements Action {
    type = ActionTypes.CLEAR_SEND_PASSWORD_RECOVERY_KEY_STATE;
    constructor(public payload: any) { }
}

export class ChangePasswordAction implements Action {
    type = ActionTypes.CHANGE_PASSWORD;
    constructor(public payload: any) { }
}
export class ChangePasswordFailAction implements Action {
    type = ActionTypes.CHANGE_PASSWORD_FAIL;
    constructor(public payload: any) { }
}
export class ChangePasswordSuccessAction implements Action {
    type = ActionTypes.CHANGE_PASSWORD_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearChangePasswordStateAction implements Action {
    type = ActionTypes.CLEAR_CHANGE_PASSWORD_STATE;
    constructor(public payload: any) { }
}

export class DoLogoutAction implements Action {
    type = ActionTypes.DO_LOGOUT;
    constructor(public payload: any) { }
}
export class DoLogoutSuccessAction implements Action {
    type = ActionTypes.DO_LOGOUT_SUCCESS;
    constructor(public payload: any) { }
}

export class GetCurrentUserAction implements Action {
    type = ActionTypes.GET_CURRENT_USER;
    constructor(public payload: any) { }
}
export class GetCurrentUserSuccessAction implements Action {
    type = ActionTypes.GET_CURRENT_USER_SUCCESS;
    constructor(public payload: any) { }
}
export class GetCurrentUserFailAction implements Action {
    type = ActionTypes.GET_CURRENT_USER_FAIL;
    constructor(public payload: any) { }
}
export class ClearGetCurrentUserStateAction implements Action {
    type = ActionTypes.CLEAR_GET_CURRENT_USER_STATE;
    constructor(public payload: any) { }
}

export class GetUsersListAction implements Action {
    type = ActionTypes.GET_USERS_LIST;
    constructor(public payload: any) { }
}
export class GetUsersListFailAction implements Action {
    type = ActionTypes.GET_USERS_LIST_FAIL;
    constructor(public payload: any) { }
}
export class GetUsersListSuccessAction implements Action {
    type = ActionTypes.GET_USERS_LIST_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearGetUsersListStateAction implements Action {
    type = ActionTypes.CLEAR_GET_USERS_LIST_STATE;
    constructor(public payload: any) { }
}

export class UpdateUserItemAction implements Action {
    type = ActionTypes.UPDATE_USER_ITEM;
    constructor(public payload: any) { }
}
export class UpdateUserItemFailAction implements Action {
    type = ActionTypes.UPDATE_USER_ITEM_FAIL;
    constructor(public payload: any) { }
}
export class UpdateUserItemSuccessAction implements Action {
    type = ActionTypes.UPDATE_USER_ITEM_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearUpdateUserItemStateAction implements Action {
    type = ActionTypes.CLEAR_UPDATE_USER_ITEM_STATE;
    constructor(public payload: any) { }
}

export class ImportUsersFromFileAction implements Action {
    type = ActionTypes.IMPORT_USERS_FROM_FILE;
    constructor(public payload: any) { }
}
export class ImportUsersFromFileFailAction implements Action {
    type = ActionTypes.IMPORT_USERS_FROM_FILE_FAIL;
    constructor(public payload: any) { }
}
export class ImportUsersFromFileSuccessAction implements Action {
    type = ActionTypes.IMPORT_USERS_FROM_FILE_SUCCESS;
    constructor(public payload: any) { }
}
export class ClearImportUsersFromFileStateAction implements Action {
    type = ActionTypes.CLEAR_IMPORT_USERS_FROM_FILE_STATE;
    constructor(public payload: any) { }
}

export class UpdateUserRoleAction implements Action {
    type = ActionTypes.UPDATE_USER_ROLE;
    constructor(public payload: any) { }
}

export class UpdateUserRoleSuccessAction implements Action {
    type = ActionTypes.UPDATE_USER_ROLE_SUCCESS;
    constructor(public payload: any) { }
}

export class UpdateUserRoleFailAction implements Action {
    type = ActionTypes.UPDATE_USER_ROLE_FAIL;
    constructor(public payload: any) { }
}

export class ClearUpdateUserRoleStateAction implements Action {
  readonly type = ActionTypes.CLEAR_UPDATE_USER_ROLE_STATE;
  constructor(public payload: any = {}) {}
}

export class RemoveUserRoleAction implements Action {
    type = ActionTypes.REMOVE_USER_ROLE;
    constructor(public payload: any) { }
}

export class RemoveUserRoleSuccessAction implements Action {
    type = ActionTypes.REMOVE_USER_ROLE_SUCCESS;
    constructor(public payload: any) { }
}

export class RemoveUserRoleFailAction implements Action {
    type = ActionTypes.REMOVE_USER_ROLE_FAIL;
    constructor(public payload: any) { }
}


export type Actions =
    | RegisterUserAction
    | RegisterUserFailAction
    | RegisterUserSuccessAction
    | ClearRegisterStateAction
    | LoginUserAction
    | LoginUserFailAction
    | LoginUserSuccessAction
    | ClearLoginStateAction
    | SendPasswordRecoveryKeyAction
    | SendPasswordRecoveryKeyFailAction
    | SendPasswordRecoveryKeySuccessAction
    | ClearSendRecoveryPasswordKeyStateAction
    | ChangePasswordAction
    | ChangePasswordFailAction
    | ChangePasswordSuccessAction
    | ClearChangePasswordStateAction
    | DoLogoutAction
    | DoLogoutSuccessAction
    | GetCurrentUserAction
    | GetCurrentUserFailAction
    | GetCurrentUserSuccessAction
    | ClearGetCurrentUserStateAction
    | GetUsersListAction
    | GetUsersListFailAction
    | GetUsersListSuccessAction
    | ClearGetUsersListStateAction
    | UpdateUserItemAction
    | UpdateUserItemFailAction
    | UpdateUserItemSuccessAction
    | ClearUpdateUserItemStateAction
    | ImportUsersFromFileAction
    | ImportUsersFromFileFailAction
    | ImportUsersFromFileSuccessAction
    | ClearImportUsersFromFileStateAction
    | UpdateUserRoleAction
    | UpdateUserRoleSuccessAction
    | UpdateUserRoleFailAction
    | ClearUpdateUserRoleStateAction
    | RemoveUserRoleAction
    | RemoveUserRoleSuccessAction
    | RemoveUserRoleFailAction

